import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AuthCallback } from "@/components/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Interview from "@/pages/Interview";
import Profile from "@/pages/Profile";
import Paths from "@/pages/Paths";
import Roadmap from "@/pages/Roadmap";
import AdminResources from "@/pages/AdminResources";
import PaymentResult from "@/pages/PaymentResult";

const guarded = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={guarded(<Dashboard />)} />
      <Route path="/interview" element={guarded(<Interview />)} />
      <Route path="/profile" element={guarded(<Profile />)} />
      <Route path="/paths" element={guarded(<Paths />)} />
      <Route path="/roadmap" element={guarded(<Roadmap />)} />
      <Route path="/admin/resources" element={guarded(<AdminResources />)} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
